__turbopack_context__.v({
  "description": "stakeholderBenefits-module-scss-module__seMSXa__description",
  "stakeholderContainer": "stakeholderBenefits-module-scss-module__seMSXa__stakeholderContainer",
  "stakeholderPattern": "stakeholderBenefits-module-scss-module__seMSXa__stakeholderPattern",
  "stakeholderSelect": "stakeholderBenefits-module-scss-module__seMSXa__stakeholderSelect",
  "stakeholderTabs": "stakeholderBenefits-module-scss-module__seMSXa__stakeholderTabs",
  "tabBenefitDescription": "stakeholderBenefits-module-scss-module__seMSXa__tabBenefitDescription",
  "tabBenefitTick": "stakeholderBenefits-module-scss-module__seMSXa__tabBenefitTick",
  "tabBenefitTitle": "stakeholderBenefits-module-scss-module__seMSXa__tabBenefitTitle",
  "tabBenefits": "stakeholderBenefits-module-scss-module__seMSXa__tabBenefits",
  "tabContentWrp": "stakeholderBenefits-module-scss-module__seMSXa__tabContentWrp",
  "tabHeading": "stakeholderBenefits-module-scss-module__seMSXa__tabHeading",
  "tabTitle": "stakeholderBenefits-module-scss-module__seMSXa__tabTitle",
});
